var render = function render(){var _vm=this,_c=_vm._self._c;return _c('NuxtLink',{staticClass:"block w-full w-[7rem] xl:w-[9.5rem] aspect-w-2 aspect-h-1 bg-contain bg-center bg-no-repeat",style:(`background-image: url(${require(`~/assets/images/logos/logo-blue.png`)})`),attrs:{"to":"/"}})
}
var staticRenderFns = []

export { render, staticRenderFns }